<template>
  <div class="flex-center-column home-process">
    <div class="title-zh">入驻流程</div>
    <div class="title-en">ENTRY PROCESS</div>
    <div class="flex-row-space-between-hCenter process-list">
      <div class="flex-row-h-center process-item">
        <img class="left-img" src="@/assets/home/process_1.png" alt="">
        <div class="index-dec">
          <img class="index-img" src="@/assets/01.png" alt="">
          <span class="dec">提交入驻资料</span>
        </div>
      </div>
      <div class="arrow">
        <img src="@/assets/home/arrow.png" alt="">
      </div>
      <div class="flex-row-h-center process-item">
        <img class="left-img" src="@/assets/home/process_4.png" alt="">
        <div class="index-dec">
          <img class="index-img" src="@/assets/02.png" alt="">
          <span class="dec">机构入驻成功</span>
        </div>
      </div>
      <div class="arrow">
        <img src="@/assets/home/arrow.png" alt="">
      </div>
      <div class="flex-row-h-center process-item">
        <img class="left-img" src="@/assets/home/process_2.png" alt="">
        <div class="index-dec">
          <img class="index-img" src="@/assets/03.png" alt="">
          <span class="dec">邀请签约达人</span>
        </div>
      </div>
      <div class="arrow">
        <img src="@/assets/home/arrow.png" alt="">
      </div>
      <div class="flex-row-h-center process-item">
        <img class="left-img" src="@/assets/home/process_3.png" alt="">
        <div class="index-dec">
          <img class="index-img" src="@/assets/04.png" alt="">
          <span class="dec">达人接受邀约</span>
        </div>
      </div>
    </div>
    <!-- 申请入驻按钮-->
    <div v-if="false" class="btn-box">
      <el-button @click="goApply()" class="apple-btn" type="primary" round>申请入驻</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-process",
  methods: {
    goApply() {
      this.$router.push('/apply/select')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-process {
  width: 1200px;
  margin: 64px auto 0;
  padding: 32px 0;

  .title-zh {
    position: relative;
    color: #1d2129;
    font-size: 24px;
    line-height: 32px;
    z-index: 1;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 8px;
      background: url("~@/assets/home/title_decoration.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      z-index: -1;
    }
  }

  .title-en {
    color: #86909c;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-top: 8px;
  }

  .process-list {
    width: 1000px;
    margin-top: 24px;

    .process-item {

      .left-img {
        width: 80px;
        height: 80px;
      }

      .index-dec {
        position: relative;
        margin-left: 16px;

        .index-img {
          position: absolute;
          top: -10px;
          left: 0;
          width: auto;
          height: 28px;
        }

        .dec {
          color: #1d2129;
          font-size: 16px;
          line-height: 24px;
          margin-left: 12px;
        }
      }
    }

    .arrow img {
      width: 20px;
      height: 4px;
    }
  }

  .btn-box {
    margin-top: 80px;

    .apple-btn {
      padding-left: 64px;
      padding-right: 64px;
    }
  }
}
</style>